import api, { BodyData } from '../../utils/api';

export interface setEnrichmentToAutoForListingsPayload extends BodyData {
    transactionalListingIds: string[];
}

const setEnrichmentToAutoForListings = async (payload: setEnrichmentToAutoForListingsPayload) => {
    return await api.post('api/transactional-listing/enrichment/instant', payload);
}

export default setEnrichmentToAutoForListings;
